var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoodNeighborhood = function SvgGoodNeighborhood(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#good-neighborhood_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M32.624 8.522q.096.002.19.008v3.055a3 3 0 0 0-.338-.021H14.211a2.706 2.706 0 1 0 0 5.412H26.05c.114 0 .227.183.338.169v.845l2.706.508c-1.025 1.206-1.2 1.477-2.896 1.52l-.148.002H14.21l-.148-.002a5.75 5.75 0 0 1 0-11.496l.148-.002h18.265z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M26.194 16.978a5.75 5.75 0 0 1 0 11.496l-.148.002H10.148v-3.044h15.898a2.706 2.706 0 0 0 0-5.412h-9.47v-2.706H12.26a5.7 5.7 0 0 1 1.799-.336l.148-.002h11.839z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M6.43 8.002c0-.186.077-.364.212-.492l4.207-3.966a.33.33 0 0 1 .255-.088l.47.044a.68.68 0 0 1 .385.166l4.389 3.868a.67.67 0 0 1 .229.507v6.127a.68.68 0 0 1-.275.545l-.139.102a.68.68 0 0 1-.4.132H7.105a.677.677 0 0 1-.676-.677z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#good-neighborhood_svg__b)",
    fillOpacity: 0.6,
    d: "M6.43 8.002c0-.186.077-.364.212-.492l4.207-3.966a.33.33 0 0 1 .255-.088l.47.044a.68.68 0 0 1 .385.166l4.389 3.868a.67.67 0 0 1 .229.507v6.127a.68.68 0 0 1-.275.545l-.139.102a.68.68 0 0 1-.4.132H7.105a.677.677 0 0 1-.676-.677z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M25.71 20.557c0-.187.079-.366.216-.494l4.646-4.333a.37.37 0 0 1 .28-.096l.541.05c.142.013.276.07.383.163l4.865 4.242a.68.68 0 0 1 .232.51v6.72c0 .216-.103.42-.278.547l-.196.142a.68.68 0 0 1-.398.13h-9.614a.676.676 0 0 1-.676-.676v-6.905Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#good-neighborhood_svg__c)",
    fillOpacity: 0.6,
    d: "M25.71 20.557c0-.187.079-.366.216-.494l4.646-4.333a.37.37 0 0 1 .28-.096l.541.05c.142.013.276.07.383.163l4.865 4.242a.68.68 0 0 1 .232.51v6.72c0 .216-.103.42-.278.547l-.196.142a.68.68 0 0 1-.398.13h-9.614a.676.676 0 0 1-.676-.676v-6.905Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M4.929 23.545a.68.68 0 0 1 .424-.66l1.124-.449a.7.7 0 0 1 .25-.048h9.704c.267 0 .483.216.483.483V35.1c0 .222-.11.43-.293.557l-.147.101a.68.68 0 0 1-.508.108L5.94 33.986a.676.676 0 0 1-.551-.633z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#good-neighborhood_svg__d)",
    fillOpacity: 0.6,
    d: "M4.929 23.545a.68.68 0 0 1 .424-.66l1.124-.449a.7.7 0 0 1 .25-.048h9.704c.267 0 .483.216.483.483V35.1c0 .222-.11.43-.293.557l-.147.101a.68.68 0 0 1-.508.108L5.94 33.986a.676.676 0 0 1-.551-.633z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.507,
    d: "M10.542 4.038a.423.423 0 0 1 .563 0l4.398 3.928c.09.08.14.195.14.315v6.327a.42.42 0 0 1-.422.423H6.427a.423.423 0 0 1-.423-.423V8.281c0-.12.05-.235.14-.315zm19.791 12.17c.16-.14.399-.14.559 0l4.905 4.323a.43.43 0 0 1 .143.318v6.95c0 .234-.19.424-.423.424h-9.809a.423.423 0 0 1-.423-.423v-6.951c0-.122.052-.238.143-.318z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.507,
    d: "M30.61 21.288c1.168 0 2.114.947 2.114 2.114v4.82h-4.228v-4.82c0-1.167.947-2.114 2.114-2.114Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.507,
    d: "M5.411 23.373H15.56c.233 0 .422.19.422.423v11.838c0 .233-.19.422-.422.423H5.41a.423.423 0 0 1-.423-.423V23.796c0-.234.19-.423.423-.423Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.596,
    height: 1.522,
    x: 7.019,
    y: 25.685,
    stroke: "#000",
    strokeWidth: 0.507,
    rx: 0.423
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.596,
    height: 1.522,
    x: 7.019,
    y: 29.068,
    stroke: "#000",
    strokeWidth: 0.507,
    rx: 0.423
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.596,
    height: 1.522,
    x: 7.019,
    y: 32.45,
    stroke: "#000",
    strokeWidth: 0.507,
    rx: 0.423
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.199,
    height: 2.199,
    x: 8.035,
    y: 9.111,
    stroke: "#000",
    strokeWidth: 0.507,
    rx: 0.423
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.199,
    height: 2.199,
    x: 11.418,
    y: 9.111,
    stroke: "#000",
    strokeWidth: 0.507,
    rx: 0.423
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "good-neighborhood_svg__b",
    x1: 18.339,
    x2: -4.894,
    y1: 9.084,
    y2: -0.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "good-neighborhood_svg__c",
    x1: 38.812,
    x2: 13.339,
    y1: 21.758,
    y2: 10.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "good-neighborhood_svg__d",
    x1: 18.911,
    x2: -6.849,
    y1: 27.681,
    y2: 16.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "good-neighborhood_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
};
export default SvgGoodNeighborhood;